module.exports = __webpack_public_path__ + "static/img/footerParallax2.30765df7.jpg";